import { Link } from "react-router-dom";
import Colors from '../../constants/Colors'
import FooterDecoration from './FooterDecoration';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();

    const navigation = t('navigation');
    return (
        <div className='bg-white position-relative'>
            <FooterDecoration />
            <div className='d-flex flex-column align-items-center pt-5'>
                <div className='d-flex flex-column flex-lg-row mt-5'>
                    {
                        navigation.map((item, index) => {
                            return (
                                <div className='mx-3 my-2' key={index}>
                                    <Link
                                        to={{
                                            pathname: item.href,
                                        }}
                                        className='text-center fw-medium fs-20 text-decoration-none'
                                        style={{ color: Colors.blue }}
                                    >
                                        {item.text}
                                    </Link>
                                </div>
                            )
                        })
                    }
                </div>

                <img
                    src={`${process.env.PUBLIC_URL}/images/footer-logo.png`}
                    style={{ height: '160px', width: 'auto' }}
                    className='my-5'
                    alt='footer-logo'
                />
            </div>
        </div>
    )
}

export default Footer